import { Button, Label, Spinner, Textarea } from 'flowbite-react';
import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { revokeCandidateOffer } from 'src/apis/application';
import { useToast } from 'src/context/ToastProvider';
import { UndoRejectCandidateAPIInput } from 'types';

const RecruiterCandidateRevokeoffer = ({
	applicationId,
	userName,
	onSubmit,
	onFinish,
	isLoading,
	positionId,
}: {
	applicationId?: string;
	userName?: string;
	isLoading?: boolean;
	positionId?: string;
	onFinish?: () => void;
	onSubmit?: (data: UndoRejectCandidateAPIInput) => void;
}) => {
	const toast = useToast();
	const queryClient = useQueryClient();
	const [reason, setReason] = React.useState('');

	const revokeOfferFn = useMutation(['revokeCandidateOffer'], revokeCandidateOffer, {
		onSuccess() {
			toast({
				title: `Revoked ${userName}'s offer`,
				type: 'success',
			});
			queryClient.refetchQueries({ queryKey: ['getRecommendationsForPosition'], exact: false });
			setReason('');
			onFinish && onFinish();
		},
		onError(error: Error) {
			toast({
				title: `Error occured ${error.message}`,
				type: 'error',
			});
		},
	});
	return (
		<form
			onSubmit={e => {
				e.preventDefault();
				if (onSubmit) onSubmit({ applicationId: applicationId ?? '', positionId: positionId ?? '', remarks: reason });
				else
					revokeOfferFn.mutate({ applicationId: applicationId ?? '', positionId: positionId ?? '', remarks: reason });
			}}
		>
			<div className="mb-[8px] flex justify-between items-end">
				<div>
					<Label>{'Reason '}</Label>
					<span className="text-[red]">*</span>

					<span className="italic text-xs text-[#6B7280] ">{(reason?.length || 0) + ' / ' + 640}</span>
				</div>
			</div>

			<Textarea
				name="message"
				value={reason}
				maxLength={640}
				placeholder="Write text here ..."
				className="border bg-white dark:text-white dark:border-[#4B5563] min-h-[185px] dark:bg-[#374151] focus:border-transparent focus:!ring-[1px] focus:!ring-[#7777E7]"
				onChange={e => {
					setReason(e.target.value);
				}}
			/>

			<Button
				type="submit"
				className="w-full mt-[20px] bg-[#7777E7]"
				color="purplePlaced"
				disabled={revokeOfferFn.isLoading || isLoading || !reason}
			>
				{revokeOfferFn.isLoading || isLoading ? <Spinner /> : 'Revoke'}
			</Button>
		</form>
	);
};

export default RecruiterCandidateRevokeoffer;
